import React, { useState, useEffect } from 'react';
import './SearchPage.scss';
import messages from './messages';
import axios from 'axios';
import SearchBar from './search/SearchBar';
import SearchHit from './search/SearchHit';

const { REACT_APP_SEARCH_API_BASEURL } = process.env;

const searchUrl = (q, p = 1) => `${REACT_APP_SEARCH_API_BASEURL ?? ''}/all/search?ft=stadat2021&start=${(p - 1) * 10}&q=${encodeURIComponent(q)}`;

const pageUrl = (lang, p, q) => `${lang === 'en' ? 'stadat_eng' : 'stadat'}?lang=${lang}&p=${p}&q=${encodeURIComponent(q)}`

const loadingData = (lang) => (
  <h3 style={{ textAlign: 'center', paddingTop: '50px' }}><p>{messages[lang].loadingSearch}</p></h3>
);

const nothingFound = (lang) => (
  <h3 style={{ textAlign: 'center', paddingTop: '50px' }}><p>{messages[lang].nothingFound}</p></h3>
);

export default function ({ lang, q, p = 1 }) {
  const trans = messages[lang];

  const [data, setData] = useState(null);
  const [hits, setHits] = useState([]);
  const [pagesCount, setPagesCount] = useState(1);

  p = Math.max(1, Math.min(parseInt(p, 10), pagesCount));

  useEffect(() => {
    axios(searchUrl(q, p))
      .then(d => {
        setData(d.data);
        setHits(d.data.docs.map(x => ({ ...x, highlight: d.data.highlighting[x.id] })));
        setPagesCount(Math.ceil(d.data.numFound / 10));
      }, console.error);
  }, [q, p]);

  return (
    <React.Fragment>
      <h1 id="content-title">{trans.searchTitle}</h1>
      <SearchBar {...{ lang, q }} />
      <div className="results-count">{data ? trans.numFound + data.numFound : ''}</div>
      { data
        ? (hits.length > 0
          ? hits.map(x => <SearchHit key={x.id} hit={x} lang={lang} />)
          : nothingFound(lang)
        )
        : loadingData(lang)
      }
      <div className="pager">
        {p > 1
          ? <span className="prev-page"><a href={pageUrl(lang, p - 1, q)}>{trans.prevPage}</a></span>
          : null
        }
        {pagesCount > 1
          ? Array.from(Array(pagesCount)).map((v, i) => (
            <span className={'nth-page' + (p === i + 1 ? ' active' : '')}>
              <a href={pageUrl(lang, i + 1, q)}>{i + 1}</a>
            </span>
          ))
          : null
        }
        {p < pagesCount
          ? <span className="next-page"><a href={pageUrl(lang, p + 1, q)}>{trans.nextPage}</a></span>
          : null
        }
      </div>
    </React.Fragment>
  );
};
